'use client'
import { Prodotto } from '@/payload-types'
import { RowLabelProps, useRowLabel } from '@payloadcms/ui'

import { formatEuro } from '@/negozio/prezzi'

export const FormatoRowLabel: React.FC<RowLabelProps> = () => {
  const { data, rowNumber } = useRowLabel<NonNullable<Prodotto['formati']>[number]>()

  const prezzo = Number.isSafeInteger(data?.prezzoCentesimi)
    ? formatEuro(data.prezzoCentesimi)
    : undefined
  const parts = [data?.sku, data?.etichetta, prezzo].filter(Boolean)

  return <div>{parts.length ? parts.join(' · ') : `Formato ${(rowNumber ?? 0) + 1}`}</div>
}
